import { render } from "./App.vue?vue&type=template&id=089b78ea&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=089b78ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089b78ea"]])

export default __exports__